import { Modal, Spin } from 'antd';
import React, { useState } from 'react';
import { addShortUrl } from '../../services/URLShortnerService';
import ShortUrlForm from './components/ShortUrlForm';

function ShortUrlAdd(props) {
  const initialValues = {
    name: '',
    longUrl: '',
    urlCode: ''
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode',
  });

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Request in Progress!' });

    await addShortUrl(values)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({ type: 'SUCCESS', message: 'Data added successfully!' });
      })
      .catch((error) => {
        alert('Getting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({ type: 'ERROR', message: error.response.data.message });
        else setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <Modal
      title={`Add Short Url`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}
    >
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <ShortUrlForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
        />
      )}
    </Modal>
  );
}

export default ShortUrlAdd;
